/* Journey planner */
$(function () {
    $('#showMoreOptions').on('click', function (e) {
        e.preventDefault();

        const $trigger = $(this);
        const $lowerFields = $('.field-group-lower');
        const $bottomFields = $('.field-group-bottom');

        $trigger.toggleClass('__active');
        $lowerFields.toggleClass('__active');
        $bottomFields.toggleClass('__active');
    });

    const $plannerToggle = $('#toggle-journey-planner');
    const $plannerPanel = $('#journey-planner');

    if ($plannerToggle.length && $plannerPanel.length) {
        const togglePlanner = function () {
            const isOpen = $plannerToggle.attr('aria-expanded') === 'true';

            $plannerToggle.attr('aria-expanded', String(!isOpen));
            $plannerPanel.stop(true, true).slideToggle(250);
        };

        $plannerPanel.hide();

        $plannerToggle.on('click', function (e) {
            e.preventDefault();
            togglePlanner();
        });

        $plannerToggle.on('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') {
                return;
            }

            e.preventDefault();
            togglePlanner();
        });
    }
});

/** Initialise the widget generator controls on load. */
(function (window, document) {

    'use strict';

    function initCopyButton() {
        const button = document.querySelector('[data-widget-copy]');
        const code = document.getElementById('widget-request-code');
        const status = document.querySelector('[data-widget-copy-status]');
        if (!button || !code || !status) return;

        button.hidden = false;
        button.addEventListener('click', async () => {
            button.disabled = true;
            status.textContent = '';
            try {
                await window.navigator.clipboard.writeText(code.value);
                status.textContent = button.dataset.copySuccess;
            } catch {
                code.focus();
                code.select();
                status.textContent = button.dataset.copyError;
            } finally {
                button.disabled = false;
            }
        });
    }

    function init() {
        initCopyButton();
        const form = document.querySelector('[data-widget-request]');

        if (!form || !window.SpindogsLocalityTypeahead) {
            return;
        }

        form.querySelectorAll('[data-widget-request-direction]').forEach(input => {

            const wrapper = input.closest('[data-widget-request-location]');
            const direction = input.dataset.widgetRequestDirection;

            window.SpindogsLocalityTypeahead.init({
                input, wrapper,
                panel: wrapper.querySelector('[data-widget-request-suggestions]'),
                status: wrapper.querySelector('[data-widget-request-status]'),
                endpoint: form.dataset.localityUrl,
                langId: form.dataset.langId,
                loadingText: form.dataset.loadingText,
                noResultsText: form.dataset.noResultsText,
                errorText: form.dataset.errorText,
                rateLimitedText: form.dataset.rateLimitedText,
                fieldMap: { name: `typeahead${direction}Name`, lat: `typeahead${direction}Lat`, lng: `typeahead${direction}Lng` },
            });
        });

        document.querySelector('[data-widget-request-errors]')?.focus();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }

})(window, document);
